import React from 'react'
import * as S from './style'

interface RadioProps {
  id?: string
  name: string
  label: string
  checked: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
}

const Radio: React.FC<RadioProps> = ({
  id,
  name,
  label,
  checked,
  onChange,
  disabled,
}) => {
  const inputId = id || `${name}-${label}`

  return (
    <S.Container>
      <S.Input
        type="radio"
        id={inputId}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <S.Label htmlFor={inputId}>{label}</S.Label>
    </S.Container>
  )
}

export default Radio
